import {
    LOADING_DATA_PROYECTO,
    SET_DATA_PROYECTO,
    SET_ERROR_PROYECTO
} from '../types'

const initialState = {
    loadingproyecto: false,
    proyecto: {},
    message: '',
    error: ''
}


export default function (state = initialState, action) {
    switch (action.type) {
        case LOADING_DATA_PROYECTO:
            return {
                ...state,
                loadingproyecto: true
            }
        case SET_DATA_PROYECTO:
            return {
                loadingproyecto: false,
                ...action.payload
            }
        case SET_ERROR_PROYECTO:
            return {
                loadingproyecto: false,
                ...action.payload
            }
        default: return state
    }
}